import React from 'react';
import AuthActions from '../actions/AuthActions';
import { withRouter, Redirect } from 'react-router-dom';
import AuthStore from '../stores/AuthStore';

class LoginFormComponent extends React.Component {

  constructor() {
    super();
    this.state = {
      login: '',
      password: '',
      error: false,
      authenticated: AuthStore.isAuthenticated()
    }
    this.onChange = this.onChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  onChange() {
    this.setState({
      authenticated: AuthStore.isAuthenticated(),
      error: AuthStore._invalid
    });
  }

  componentWillMount() {
    AuthStore.addChangeListener(this.onChange);
  }

  componentWillUnmount() {
    AuthStore.removeChangeListener(this.onChange);
  }

  handleChange(event) {
    const target = event.target;
    this.setState({
      [target.name]: target.value
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    AuthActions.logUserIn(this.state.login, this.state.password);
  }

  render() {
    return (
      <div className="login_form">
        { !this.state.authenticated ? (
          <form onSubmit={this.handleSubmit}>
            <h2>Zaloguj się, aby rozpocząć</h2>
            <input
              placeholder="login"
              name="login"
              type="text"
              value={this.state.login}
              onChange={this.handleChange} />
            <input
              placeholder="password"
              name="password"
              type="password"
              value={this.state.password}
              onChange={this.handleChange} />
            <input type="submit" value="OK" className="button" />
            { this.state.error &&
              <div className="login-failed">
                Nieprawidłowy login lub hasło!
              </div>
            }
          </form>
        ) : (
          <Redirect to='/' />
        )}
      </div>
    );
  }
}

export default withRouter(LoginFormComponent);



// WEBPACK FOOTER //
// ./src/components/LoginForm.js